export const environment = {
  production: false,
  backendUrl: '/api',
  auth: '',
  basicPass: 'Basic YWRtaW46SGFpbmVAMTA=',
};
